import React from 'react';
import ChatInputDesktop from './ChatInputDesktop';
import { ChatInputMobile } from './ChatInputMobile';
import { useMediaQuery, useTheme } from '@material-ui/core';

interface ChatInputProps {
    isActive: boolean;
    messageText: string;
    onMessageChange: (text: string) => void;
    onSendMessage: () => void;
}

const ChatInputWrapper: React.FC<ChatInputProps> = props => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return isMobile ? <ChatInputMobile {...props} /> : <ChatInputDesktop {...props} />;
};

export default ChatInputWrapper;
